var _defs, _path, _path2, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 274.62 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#CECECE;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.36,31.6a2.52,2.52,0,1,1-2.51,2.51,2.52,2.52,0,0,1,2.51-2.51m0-.37a2.89,2.89,0,1,0,2.89,2.88,2.88,2.88,0,0,0-2.89-2.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.32,35.82a1.71,1.71,0,1,1,1.17-3l-.26.27a1.34,1.34,0,1,0-.91,2.31,1.3,1.3,0,0,0,.91-.37l.26.28A1.71,1.71,0,0,1,245.32,35.82Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.37,
    y: 10.85,
    width: 10.85,
    height: 26.14
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.05 0 0 12.05 0 36.99 10.85 36.99 10.85 16.54 16.54 10.85 54.37 10.85 54.37 0 12.05 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.43 12.05 136.43 36.99 147.27 36.99 147.27 18.51 165.77 37 181.1 37 154.95 10.85 201.64 10.85 201.64 0 148.48 0 136.43 12.05"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "138.09 6.13 131.96 0 80.26 0 80.26 0 68.22 12.05 68.22 36.99 79.06 36.99 79.06 16.54 84.75 10.85 118.03 10.85 102.73 26.14 81.99 26.14 81.99 36.99 133.35 36.99 133.35 26.14 118.07 26.14 133.37 10.85 138.09 6.13"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "259.28 0 233.14 26.14 248.47 26.14 274.62 0 259.28 0"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "221.14 26.14 215.45 20.45 215.45 0 204.6 0 204.6 24.94 216.65 36.99 233.14 36.99 233.14 26.14 233.14 26.14 221.14 26.14"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.070ae57b2964293bcf8b0b9ff17ebd29.svg";
export { ForwardRef as ReactComponent };